var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"HakunaSubtotal mt24 mb24",attrs:{"align":"right"}},[_c('h1',{staticStyle:{"color":"#232323"}},[_vm._v("Subtotal "),_c('strong',[_vm._v(_vm._s(_vm.$nF(_vm.subtotal)))])]),_c('br')])
}
var staticRenderFns = []

export { render, staticRenderFns }